import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import profile from '../assets/images/profile.jpg';
import banner1 from '../assets/images/banner1.webp';
import { Container, Row, Col, Button, Tabs, Tab } from 'react-bootstrap';
import EditProfileModal from '../components/EditProfile';
import ChangePasswordModal from '../components/ChangePasswordModal';
import DownloadList from '../components/DownloadList'
import PaymentList from '../components/PaymentList'
import OrderList from '../components/OrderList'



const downloads = [
  { name: 'Music_video_concept1.avi', size: '78 MB', date: '17.06.25' },
  { name: 'Youtube_tutorial_part1.mp4', size: '656 MB', date: '16.06.25' },
  { name: 'Instagram_reel_cooking_show.mp4', size: '234 MB', date: '15.06.25' },
  { name: 'Corporate_intro_promo.mov', size: '30 MB', date: '13.06.25' },
  { name: 'Car_showcase_demo.mp4', size: '60 MB', date: '12.06.25' },
  { name: 'Podcast_episode_05_video.mp4', size: '7 MB', date: '10.06.25' },
];

function Profile() {
  const [showModal, setShowModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  return (
    <>
      <Header />
      <main className='profile'>
        <div className="profile-element" style={{ backgroundImage: `url(${banner1})`, }}>
          <Container style={{ position: 'relative' }}>
            <div className='profile-image'>
              <img src={profile} alt="profile" />
            </div>
          </Container>
        </div>
        <Container className='profile-content'>
          <Row>
            <Col md={6} xs={12}>
              <h4>Alexander Banner</h4>
              <p className="mb-1"><span>Email:</span>alexander.banner@gmail.com</p>
              <p className="mb-3"><span>Phone:</span>+ 4912345678</p>
              <div className='btn-section'>
                <Button type="button" className="btn btn-primary btn-sm" onClick={() => setShowModal(true)}>
                  Edit Profile
                </Button>
                <Button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowPasswordModal(true)}>
                  Change Password
                </Button>
              </div>
            </Col>
            <Col md={6} xs={12}>
              <div className="package-card active-package">
                <div className="package-status">
                  <span className="status-dot" /> Active Package
                </div>

                <div className="package-title">YouTube Insta TikTok Videos</div>

                <div className="package-details">
                  <div className="package-info">
                    <div>Basic Cut and audio</div>
                    <div>5 minutes</div>
                  </div>
                  <div className="package-price">€54.99</div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="profile-other-content mt-4">
          <Tabs defaultActiveKey="downloads" id="profile-tabs" className="mb-3">
            <Tab eventKey="downloads" title="Downloads">
              <DownloadList downloads={downloads} />
            </Tab>
            <Tab eventKey="orders" title="Orders">
              <OrderList />
            </Tab>
            <Tab eventKey="payments" title="My Payments">
              <PaymentList />
            </Tab>

          </Tabs>
        </Container>
      </main>
      <Footer />
      <EditProfileModal
        showModal={showModal}
        handleClose={() => setShowModal(false)}
      />
      <ChangePasswordModal
        showModal={showPasswordModal}
        handleClose={() => setShowPasswordModal(false)}
      />
    </>
  );
}

export default Profile;
